import React from 'react'
import { cn } from 'src/sites/kits/Utils'
import PropTypes from 'prop-types'

const Title = ({ children, className, size, ...props }) => {
   const baseStyle = 'block text-neutral-900'
   const sizeClass = {
      xs: 'text-sm font-semibold',
      sm: 'text-base font-semibold',
      md: '',
      lg: ''
   }[size]

   return (
      <div className={cn(baseStyle, sizeClass, className)}
         {...props}>
         {children}
      </div>
   )
}

Title.propTypes = {
   children: PropTypes.node,
   className: PropTypes.string,
   size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg'])
}

Title.defaultProps = {
   children: '',
   className: '',
   size: 'md'
}

export default Title
